/**
 * Loader
 */
const tubeColor = '#ccc';
const polygoneColor = '#EBD5B1';
const circle1Color = '#A5CDE2';
const circle2Color = '#001022';

let canvas;
let ctx;
let cw;
let ch;
let requestId;
let y;


function fillColorTube() {
  ctx.beginPath();
  ctx.moveTo(0, y);
  for (let x = 0; x < cw; x += 20) {
    ctx.quadraticCurveTo(x + 10, y, x + 10, y);
  }
  ctx.lineTo(cw, ch);
  ctx.lineTo(0, ch);
  ctx.closePath();
  ctx.fillStyle = tubeColor;
  ctx.fill();
}

function fillColorPolygone() {
  ctx.beginPath();
  ctx.moveTo(0, y);
  for (let x = 0; x < cw; x += 20) {
    ctx.quadraticCurveTo(x + 1, y, x + 1, y);
  }
  ctx.lineTo(cw, ch);
  ctx.lineTo(0, ch);
  ctx.closePath();
  ctx.fillStyle = polygoneColor;
  ctx.fill();
}

function fillColorCircle1() {
  ctx.beginPath();
  ctx.moveTo(0, y);
  for (let x = 0; x < cw; x += 20) {
    ctx.quadraticCurveTo(x + 1, y, x + 1, y);
  }
  ctx.lineTo(cw, ch);
  ctx.lineTo(0, ch);
  ctx.closePath();
  ctx.fillStyle = circle1Color;
  ctx.fill();
}

function fillColorCircle2() {
  ctx.beginPath();
  ctx.moveTo(0, y);
  for (let x = 0; x < cw; x += 20) {
    ctx.quadraticCurveTo(x + 1, y, x + 1, y);
  }
  ctx.lineTo(cw, ch);
  ctx.lineTo(0, ch);
  ctx.closePath();
  ctx.fillStyle = circle2Color;
  ctx.fill();
}

function drawLine1() {
  ctx.beginPath();
  ctx.moveTo(14.6666667, 44);
  ctx.lineTo(78, 44);
  ctx.lineWidth = 1;
  ctx.stroke();
}

function drawLine2() {
  ctx.beginPath();
  ctx.moveTo(10.6666667, 122);
  ctx.lineTo(82, 122);
  ctx.lineWidth = 1;
  ctx.stroke();
}

function drawPolygone(linewidth, strokestyle, fillstyle) {
  ctx.beginPath();
  ctx.moveTo(15.1408451, 45);
  ctx.lineTo(77.8591549, 45);
  ctx.lineTo(82.5, 123.239998);
  ctx.lineTo(10, 123.239998);
  ctx.lineTo(15.1408451, 45);
  ctx.closePath();
  ctx.lineWidth = linewidth;
  ctx.strokeStyle = strokestyle;
  if (fillstyle) {
    ctx.fillStyle = fillstyle;
  }
  ctx.clip();
}

function drawCircle1(linewidth, strokestyle, fillstyle) {
  ctx.beginPath();
  ctx.arc(46, 82.6666667, 28, 0, 6.283185307179586, true);
  ctx.closePath();
  ctx.lineWidth = linewidth;
  ctx.strokeStyle = strokestyle;
  if (fillstyle) {
    ctx.fillStyle = fillstyle;
  }
  ctx.stroke();
  ctx.clip();
}

function drawCircle2(linewidth, strokestyle, fillstyle) {
  ctx.beginPath();
  ctx.arc(46, 83.3333333, 15.3333333, 0, 6.283185307179586, true);
  ctx.closePath();
  ctx.lineWidth = linewidth;
  ctx.strokeStyle = strokestyle;
  if (fillstyle) {
    ctx.fillStyle = fillstyle;
  }
  ctx.stroke();
  ctx.clip();
}

function drawContainer(linewidth, strokestyle, fillstyle) {
  ctx.beginPath();
  ctx.moveTo(92, 264);
  ctx.lineTo(92, 256.7);
  ctx.bezierCurveTo(90.2, 254.1, 89.1, 250.29999999999998, 88.8, 245.29999999999998);
  ctx.bezierCurveTo(88.5, 240.29999999999998, 84.6, 168.09999999999997, 77, 28.49999999999997);
  ctx.lineTo(77, 28.49999999999997);
  ctx.bezierCurveTo(77, 27.799999999999972, 76.6, 27.19999999999997, 76, 26.89999999999997);
  ctx.lineTo(57.4, 16.8);
  ctx.bezierCurveTo(57, 16.6, 56.8, 16.2, 56.8, 15.700000000000001);
  ctx.lineTo(56.8, 15.700000000000001);
  ctx.bezierCurveTo(56.8, 15.3, 57.099999999999994, 15.000000000000002, 57.5, 15.000000000000002);
  ctx.lineTo(57.7, 15.000000000000002);
  ctx.bezierCurveTo(58.2, 15.000000000000002, 58.7, 14.600000000000001, 58.7, 14.000000000000002);
  ctx.lineTo(58.7, 8.8);
  ctx.bezierCurveTo(58.7, 7.9, 59.400000000000006, 7.000000000000001, 60.300000000000004, 6.800000000000001);
  ctx.lineTo(61.300000000000004, 6.6000000000000005);
  ctx.bezierCurveTo(62.2, 6.4, 62.900000000000006, 5.6000000000000005, 62.900000000000006, 4.6000000000000005);
  ctx.lineTo(62.900000000000006, 3.3);
  ctx.bezierCurveTo(62.900000000000006, 2.4, 62.400000000000006, 1.6999999999999997, 61.50000000000001, 1.4);
  ctx.lineTo(57.60000000000001, 0.09999999999999987);
  ctx.bezierCurveTo(57.3, 0, 57.1, 0, 56.9, 0);
  ctx.lineTo(35.1, 0);
  ctx.bezierCurveTo(34.9, 0, 34.7, 0, 34.5, 0.1);
  ctx.lineTo(30.7, 1.3);
  ctx.bezierCurveTo(29.9, 1.6, 29.3, 2.3, 29.3, 3.2);
  ctx.lineTo(29.3, 4.7);
  ctx.bezierCurveTo(29.3, 5.7, 30, 6.5, 31, 6.7);
  ctx.lineTo(31.7, 6.8);
  ctx.bezierCurveTo(32.7, 7, 33.4, 7.8, 33.4, 8.8);
  ctx.lineTo(33.4, 14.100000000000001);
  ctx.bezierCurveTo(33.4, 14.700000000000001, 33.8, 15.100000000000001, 34.4, 15.100000000000001);
  ctx.lineTo(34.699999999999996, 15.100000000000001);
  ctx.bezierCurveTo(35.099999999999994, 15.100000000000001, 35.4, 15.400000000000002, 35.4, 15.8);
  ctx.lineTo(35.4, 15.8);
  ctx.bezierCurveTo(35.4, 16.2, 35.199999999999996, 16.6, 34.8, 16.8);
  ctx.lineTo(16.3, 26.9);
  ctx.bezierCurveTo(15.700000000000001, 27.2, 15.3, 27.9, 15.3, 28.5);
  ctx.bezierCurveTo(8.2, 166, 4.2, 238.3, 3.3, 245.3);
  ctx.bezierCurveTo(2.4, 252.4, 1.2999999999999998, 256.2, 0, 256.7);
  ctx.lineTo(0, 264);
  ctx.lineTo(92, 264);
  ctx.closePath();
  ctx.lineWidth = linewidth;
  ctx.strokeStyle = strokestyle;
  if (fillstyle) {
    ctx.fillStyle = fillstyle;
  }
  ctx.stroke();
  ctx.clip();
}

function animate() {
  if (y > 0) {
    requestId = requestAnimationFrame(animate);
  }

  ctx.clearRect(0, 0, cw, ch);
  ctx.beginPath();

  // Draw and Fill the tube
  ctx.save();
  drawContainer(1, '#000', null);
  fillColorTube();
  ctx.restore();

  // Draw line 1
  ctx.save();
  drawLine1();
  ctx.restore();

  // Draw and Fill the polygon
  ctx.save();
  drawPolygone(1, '#000', null);
  fillColorPolygone();
  ctx.restore();

  // Draw line 2
  ctx.save();
  drawLine2();
  ctx.restore();

  // Draw and Fill circle 1
  ctx.save();
  drawCircle1(1, '#000', null);
  fillColorCircle1();
  ctx.restore();

  // Draw and Fill circle 2
  ctx.save();
  drawCircle2(1, '#000', null);
  fillColorCircle2();
  ctx.restore();

  y -= 1;

  if (y === 0) {
    if (requestId) {
      cancelAnimationFrame(requestId);
    }
    y = 339;
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    animate();
  }
}

/**
 * Init Loader Instant search
 */
function instantSearchLoaderInit() {
  // console.log('$("#loaderInstantSearch").length', $('#loaderInstantSearch').length);

  if ($('#loaderInstantSearch').length > 0) {
    canvas = document.getElementById('loaderInstantSearch');
    ctx = canvas.getContext('2d');
    cw = canvas.width;
    ch = canvas.height;
    y = ch - 10;
    ctx.lineCap = 'round';
    ctx.lineJoin = 'round';
    // ctx.scale(1.6, 1.6);
    ctx.translate(1, 1);
    ctx.imageSmoothingEnabled = false;
    animate();
  }
}

export {
  instantSearchLoaderInit,
};

export default instantSearchLoaderInit;




// WEBPACK FOOTER //
// ./js/common/molecule/loader-instant-search.js